<div class="dir-rtl w-full">
  @if (rows().length > 0) {
    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
      @for (rowItem of rows(); track rowItem["id"] || $index) {
        <div
          class="relative flex flex-col justify-between rounded-2xl border border-gray-100 bg-white p-4 shadow-sm transition-all hover:shadow-md">
          <div class="flex flex-col border-b border-gray-50 pb-3">
            <div class="flex items-start justify-between">
              <div class="text-right">
                <h3 class="text-xl font-extrabold text-gray-900 underline decoration-gray-900 underline-offset-4">
                  #{{ rowItem["id"] }}
                </h3>
              </div>

              @if (rowItem["isEditable"] !== false && currentActions()?.length) {
                <div class="relative">
                  <app-action-icon
                    [isOpen]="activeDropdownId() === rowItem['id']"
                    [entityId]="rowItem['id']"
                    (openDropDown)="toggleRow($event)"
                    (closeDropDown)="toggleRow(null)" />

                  @if (activeDropdownId() === rowItem["id"]) {
                    <div
                      [class]="isArabic() ? 'left-0' : 'right-0'"
                      class="absolute top-full z-50 mt-1 flex w-44 flex-col gap-1 rounded-lg border border-gray-100 bg-white p-1 shadow-xl">
                      @for (action of currentActions(); track action.id) {
                        <button
                          (click)="onHandleAction($event, action.id, rowItem)"
                          class="w-full rounded-md px-3 py-2 text-right text-xs font-medium text-gray-700 hover:bg-gray-50">
                          {{ isArabic() ? action.titleAr : action.titleEn }}
                        </button>
                      }
                    </div>
                  }
                </div>
              }
            </div>

            <div class="mt-2">
              @for (item of headerItems(); track item.key) {
                @if (item.type === "status" && rowItem[item.key]) {
                  <span
                    [class]="
                      getStatusClass(rowItem[item.key]?.titleEn || rowItem[item.key]?.titleAr || rowItem[item.key])
                    "
                    class="inline-block rounded-full px-4 py-1 text-sm font-bold shadow-xs">
                    {{
                      isArabic()
                        ? rowItem[item.key]?.titleAr || rowItem[item.key]
                        : rowItem[item.key]?.titleEn || rowItem[item.key]
                    }}
                  </span>
                }
              }
            </div>
          </div>

          <div class="my-3 text-right">
            @for (item of headerItems(); track item.key) {
              @if (item.position === "body" && rowItem[item.key] !== undefined && rowItem[item.key] !== null) {
                <p class="text-sm font-normal text-gray-600">
                  {{ getLabel(item) }}:

                  <span class="font-semibold underline decoration-gray-300 underline-offset-2">
                    {{ formatValue(rowItem[item.key], item) }}
                  </span>
                </p>
              }
            }
          </div>

          <div class="mt-1 flex items-end justify-between text-xs text-gray-500">
            <div class="flex items-center gap-4 font-bold text-gray-800">
              @for (item of headerItems(); track item.key) {
                @if (item.position === "footer" && item.type === "currency" && rowItem[item.key] !== undefined) {
                  <div class="flex items-center gap-1.5">
                    @if (item.key === "amount1") {
                      <app-pharmacy-icon></app-pharmacy-icon>
                    }

                    @if (item.key === "amount2") {
                      <app-people-icon></app-people-icon>
                    }

                    <span class="text-base">
                      {{ rowItem[item.key] | egpPipe: isArabic() }}
                    </span>
                  </div>
                }
              }
            </div>

            <div class="space-y-1 text-left">
              @for (item of headerItems(); track item.key) {
                @if (item.position === "footer" && item.type === "date" && rowItem[item.key]) {
                  <span class="block text-xs font-medium text-gray-400">
                    {{ rowItem[item.key] | date }}
                  </span>
                }

                @if (item.position === "footer" && item.key === "createdBy" && rowItem[item.key]) {
                  <span class="block text-xs font-semibold text-gray-500">
                    {{ rowItem[item.key] }}
                  </span>
                }
              }
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="rounded-2xl border border-gray-100 bg-white p-8 text-center shadow-sm">
      @if (isFiltersApplied()) {
        <app-empty-data [title]="emptyFilterTitle()!" />
      } @else {
        <app-empty-data [title]="emptyContentTitle()!" [description]="emptyContentDescription()" />
      }
    </div>
  }
</div>
